import type { ValuesOf } from '@tmapy/beetlejuice-utils';

import { ServiceOrderListStateEnum } from '../openapi/types/ServiceOrderListStateEnum';

/**
 * Enum:
 * - DRAFT — rozpracovaná, cena se počítá živě z ceníku
 * - CREATED — potvrzená, cena zmražená, vznikl podklad pro fakturu
 * - PAID — zaplacená, vznikl daňový doklad
 */
export const SERVICE_ORDER_STATE = ServiceOrderListStateEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SERVICE_ORDER_STATE = ValuesOf<typeof SERVICE_ORDER_STATE>;

/**
 * Ceník se změnil mezi zobrazením draftu a potvrzením — server vrací 409 a v těle
 * `current_price`. Není to selhání requestu, jen se pracovnici musí ukázat nová cena.
 */
export const SERVICE_ORDER_PRICE_CHANGED_CODE = 'vydej_service_order_price_changed';

/** Zápis jiného pole než `note` do žádosti, kterou mezitím někdo potvrdil. */
export const SERVICE_ORDER_NOT_DRAFT_CODE = 'vydej_service_order_not_draft';

/** Zápis poznámky do žádosti, kterou mezitím někdo označil jako zaplacenou. */
export const SERVICE_ORDER_NOTE_LOCKED_CODE = 'vydej_service_order_note_locked';

/** Žadatel nebo odběratel nemá v profilu údaje potřebné na doklad. */
export const SERVICE_ORDER_PARTY_INCOMPLETE_CODE = 'vydej_service_order_party_incomplete';
